module.exports = __webpack_public_path__ + "static/media/bevege.9b8de1ee.m4a";